import { EntityRequestCaruse } from "../../entity/EntityRequestCaruse";

export class DtoRequestCarusesDeleteRes extends EntityRequestCaruse {
  public message: string | null = null;
}
